import { useParams } from 'react-router';
import { TopBar } from 'shared-ui';
import { useFormContext } from 'react-hook-form';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRouteWithParams } from 'routing/AppRoute.enum';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';
import { UserPermissionsForm } from '../UserPermissions.types';
import * as Styled from '../UserPermissions.styles';

import { UserPermissionsBarProps } from './UserPermissionsBar.types';

export const UserPermissionsBar = ({ onSubmit, isSaving, onCancel }: UserPermissionsBarProps) => {
  const { formatMessage } = useLocale();
  const { id } = useParams<{ id: string }>();

  const {
    watch,
    formState: { isDirty },
  } = useFormContext<UserPermissionsForm>();

  const { accessAllData, selectedOrganizations } = watch();

  const isUserDataPermissionsView = useIsExactPath(AppRouteWithParams.userDataPermissions.path);
  const isUserFunctionalPermissionsView = useIsExactPath(AppRouteWithParams.userFunctionalPermissions.path);

  return (
    <TopBar gridTemplateColumns="auto auto 1fr auto auto" style={{ marginBottom: 24 }}>
      <TopBar.Link
        linkTo={AppRouteWithParams.userDataPermissions.get({ id: id || '' })}
        isActive={isUserDataPermissionsView}
      >
        {formatMessage({ id: AppMessages['permissions.dataPermissions'] })}
      </TopBar.Link>

      <TopBar.Link
        linkTo={AppRouteWithParams.userFunctionalPermissions.get({ id: id || '' })}
        isActive={isUserFunctionalPermissionsView}
      >
        {formatMessage({ id: AppMessages['permissions.functionalPermissions'] })}
      </TopBar.Link>

      <TopBar.EmptyBarWithLine />

      <Styled.TopBarButton
        variant="outlined"
        disabled={isSaving || !isDirty}
        onClick={onCancel}
        style={{ marginRight: 16 }}
      >
        {formatMessage({ id: AppMessages['common.cancel'] })}
      </Styled.TopBarButton>

      <Styled.TopBarButton
        disabled={!isDirty || (isUserDataPermissionsView && !accessAllData && selectedOrganizations.length === 0)}
        isLoading={isSaving}
        onClick={onSubmit}
      >
        {formatMessage({ id: AppMessages['common.save'] })}
      </Styled.TopBarButton>
    </TopBar>
  );
};
